import PropTypes from 'prop-types';
import { authorPropTypes } from './components/Author/AuthorPropTypes';
import { authorDetailsPropTypes } from '@Theme/natucare/components/Tooltip/modules/AuthorDetails/AuthorDetailsPropTypes';
export const editorialTeamPropTypes = {
  /**
   * Editorial team: array of objects
   */
  editorialTeam: PropTypes.arrayOf(PropTypes.shape({
    ...authorPropTypes,
    href: PropTypes.string,
    role: PropTypes.string,
    details: authorDetailsPropTypes.details
  }))
};